import hostURL from "./constants";
import secureLocalStorage from "react-secure-storage";

const getAuthToken = () => secureLocalStorage.getItem("token");

let myCommonApiCall = [];

myCommonApiCall.storeSearchData = async (values, sroute) => {
  const formData = {
    userId: secureLocalStorage.getItem("userRef"),
    route: window.location.href,
    subRoute: sroute,
    formData: JSON.stringify(values),
  };

  const authToken = getAuthToken();

  await fetch(hostURL + "api/usersearchdata", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authToken || "",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .catch((error) => console.error(error));
};

myCommonApiCall.signOut = async () => {
  const authToken = getAuthToken();

  try {
    const response = await fetch(hostURL + "api/users/signOut", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authToken || "",
      },
    });

    const json = await response.json().catch(() => ({}));

    return {
      status: response.status,
      ok: response.ok,
      json,
    };
  } catch (error) {
    console.error("signOut failed:", error);
    return {
      status: 0,
      ok: false,
      json: {},
    };
  }
};

myCommonApiCall.clearLocalSession = () => {
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  secureLocalStorage.removeItem("token");
  secureLocalStorage.removeItem("refreshToken");
  secureLocalStorage.removeItem("userRef");
};

myCommonApiCall.refreshToken = async () => {
  const body = {
    refreshToken: secureLocalStorage.getItem("refreshToken"),
  };

  try {
    const response = await fetch(hostURL + "api/users/refreshToken", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const json = await response.json().catch(() => ({}));

    if (response.status === 200 && json.signInToken) {
      secureLocalStorage.setItem("token", json.signInToken);
    }

    return {
      status: response.status,
      ok: response.ok,
      json,
    };
  } catch (error) {
    console.error("refreshToken failed:", error);
    return {
      status: 0,
      ok: false,
      json: {},
    };
  }
};

export default myCommonApiCall;
